export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', () => {
    document.getElementsByTagName('main')?.[0]?.scrollTo({ top: 0 })
  })
})
